import { render, staticRenderFns } from "./ProductEquivalents.vue?vue&type=template&id=b614ff22&scoped=true"
import script from "./ProductEquivalents.vue?vue&type=script&lang=js"
export * from "./ProductEquivalents.vue?vue&type=script&lang=js"
import style0 from "./ProductEquivalents.vue?vue&type=style&index=0&id=b614ff22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b614ff22",
  null
  
)

export default component.exports